// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2_1ex","errors":"Errors_errors__339A3"};